import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';
import { Empresa, EmpresaRequest } from '../models/empresa.model';
declare var bootstrap: any;

@Component({
  selector: 'app-empresa-modal',
  templateUrl: './empresa-modal.component.html',
  styleUrls: ['./empresa-modal.component.css'],
})
export class EmpresaModalComponent implements OnInit {
  @Output() empresaGuardada = new EventEmitter<void>();
  @Output() empresaActualizada = new EventEmitter<void>();
  @Output() empresaEliminada = new EventEmitter<void>();
  @Output() empresaModalCancelado = new EventEmitter<void>();

  empresa: Empresa = this.getEmpresaVacia();
  modoEditar: boolean = false;
  modoEliminar: boolean = false;
  errores: { [key: string]: string } = {};

  constructor(
    private apiSrv: ApiService,
    private toastSrv: ToastService,
    private loadingSrv: LoadingService
  ) {}

  ngOnInit(): void {}

  getEmpresaVacia(): Empresa {
    return {
      cuit: null,
      razonSocial: '',
    };
  }

  abrirModoCreacionEmpresa(): void {
    this.modoEditar = false;
    this.modoEliminar = false;
    this.empresa = this.getEmpresaVacia();
    this.errores = {};
    this.mostrarModal();
  }

  abrirModoEdicionEmpresa(empresa: Empresa): void {
    this.modoEditar = true;
    this.modoEliminar = false;
    this.empresa = { ...empresa };
    this.errores = {};
    this.mostrarModal();
  }

  abrirModoEliminacionEmpresa(empresa: Empresa): void {
    this.modoEditar = false;
    this.modoEliminar = true;
    this.empresa = { ...empresa };
    this.errores = {};
    this.mostrarModal();
  }

  mostrarModal(): void {
    const modalElement = document.getElementById('empresaModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();

      modalElement.addEventListener(
        'hidden.bs.modal',
        () => {
          this.cerrarModalEmpresa();
        },
        { once: true }
      );
    }
  }

  cerrarModalEmpresa(): void {
    const modalElement = document.getElementById('empresaModal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    // Emitir evento para que el componente padre sepa que el modal fue cancelado
    this.empresaModalCancelado.emit();
  }

  guardarEmpresa(): void {
    this.loadingSrv.setLoading(true);
    if (this.validarEmpresa()) {
      const empresaRequest: EmpresaRequest = {
        cuit: this.empresa.cuit!,
        razonSocial: this.empresa.razonSocial,
      };

      if (this.modoEditar) {
        this.actualizarEmpresa(empresaRequest);
      } else {
        this.crearEmpresa(empresaRequest);
      }
    } else {
      this.loadingSrv.setLoading(false);
    }
  }

  crearEmpresa(empresaRequest: EmpresaRequest): void {
    this.apiSrv.crearEmpresa(empresaRequest).subscribe({
      next: (response) => {
        if (response.status === 200 || response.status === 201) {
          this.cerrarModalEmpresa();

          setTimeout(() => {
            this.empresa = this.getEmpresaVacia();
            this.empresaGuardada.emit();

            this.toastSrv.mostrarNotificacion(
              'Empresa creada correctamente',
              'success'
            );
          }, 300);
        }
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          `Error al crear la empresa: ${error.error}`,
          'error'
        );
      },
    });
  }

  actualizarEmpresa(empresaRequest: EmpresaRequest): void {
    this.apiSrv.actualizarEmpresa(empresaRequest).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.cerrarModalEmpresa();

          setTimeout(() => {
            this.empresa = this.getEmpresaVacia();
            this.empresaActualizada.emit();

            this.toastSrv.mostrarNotificacion(
              'Empresa actualizada correctamente',
              'success'
            );
          }, 300);
        }
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          `Error al actualizar la empresa: ${error.error}`,
          'error'
        );
      },
    });
  }

  eliminarEmpresa(): void {
    if (!this.empresa.cuit) {
      this.toastSrv.mostrarNotificacion(
        'No se puede eliminar una empresa sin CUIT',
        'error'
      );
      return;
    }

    this.loadingSrv.setLoading(true);
    this.apiSrv.eliminarEmpresa(this.empresa.cuit).subscribe({
      next: (response) => {
        if (response.status === 200 || response.status === 204) {
          this.cerrarModalEmpresa();

          setTimeout(() => {
            this.empresa = this.getEmpresaVacia();
            this.empresaEliminada.emit();

            this.toastSrv.mostrarNotificacion(
              'Empresa eliminada correctamente',
              'success'
            );
          }, 300);
        }
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          `Error al eliminar la empresa: ${error.error}`,
          'error'
        );
      },
    });
  }

  validarEmpresa(): boolean {
    this.errores = {};

    // Validación de CUIT (debe ser un número válido)
    if (!this.empresa.cuit) {
      this.errores['cuit'] = 'El CUIT es requerido';
    } else if (!/^\d{11}$/.test(this.empresa.cuit.toString())) {
      this.errores['cuit'] = 'El CUIT debe tener 11 dígitos';
    }

    // Validación de razón social
    if (!this.empresa.razonSocial) {
      this.errores['razonSocial'] = 'La razón social es requerida';
    } else if (this.empresa.razonSocial.length < 3) {
      this.errores['razonSocial'] =
        'La razón social debe tener al menos 3 caracteres';
    }

    return Object.keys(this.errores).length === 0;
  }
}
